<template lang="pug">
  v-popover(
    trigger='manual'
    :delay='{ show: 300, hide: 1000 }'
    :popoverClass='styleClass'
    autoHide
    :open='active'
  )
    div(@mouseenter='setActive(true)' @mouseleave='setActive(false)')
      slot
    template(slot='popover')
      .author-tooltip(@mouseenter='setActive(true)' @mouseleave='setActive(false)')
        .author-description
          .row.m-bottom-1
            .row
              img.author-avatar-tt(:src='author.picture || defaultImage' alt='author avatar')
            .column
              h4.author-name.text-xbig
                | {{ author.name }}
              h6.text-normal.dark-gray
                | {{ author.description }}
          p.text-normal.m-bottom-3
            | {{ author.bio }}
        .external.row.space-between.middle(v-if='external')
          .web-box.column(v-if='author.website')
            h2.text-small.dark-gray
              | Website
            a.web-link.text-normal.blue.underline(:href='author.website' target='_blank' rel='noreferrer noopener')
              | {{ author.website }}
          .row(v-if='social')
            a(v-if='author.facebook' :href='author.facebook' target='_blank' rel='noreferrer noopener')
              img.social-icon(src='../assets/ic_facebook.svg')
            a(v-if='author.instagram' :href='author.instagram' target='_blank' rel='noreferrer noopener')
              img.social-icon(src='../assets/ic_instagram.svg')
            a(v-if='author.twitter' :href='author.  twitter' target='_blank' rel='noreferrer noopener')
              img.social-icon(src='../assets/ic_twitter.svg')
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

import defaultImage from '@/assets/empty_profile.svg'

export default {
  data() {
    return {
      defaultImage,
      active: false
    }
  },
  props: {
    author: {
      type: Object,
      required: true
    },
    styleClass: {
      type: String,
      required: true
    }
  },
  computed: {
    social() {
      return this.author.facebook || this.author.instagram || this.author.twitter
    },
    external() {
      return this.social || this.author.website
    }
  },
  methods: {
    setActive(status) {
      this.active = status
    }
  },
  mixins: [ clickaway ]
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';

.author-tooltip {
  width: 100%;
  max-width: 345px;
  background-color: $white;
}

.author-description {
  padding: 30px 25px 0;
}

.author-avatar-tt {
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  border: 1px solid $light-gray;
  border-radius: 100%;
  margin-right: 20px;
}

.author-name {
  margin-bottom: 5px;
}

.external {
  background-color: $light-gray;
  padding: 18px 0 18px 18px;
}

.web-box::before {
  content: '';
  height: 40px;
  border-right: 1px solid $white;
  position: absolute;
  left: 170px;
}

.web-link {
  display: inline-block;
  width: 140px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.social-icon {
  margin-right: 25px;
  height: 25px;
  width: 25px;
}
</style>
